export const PlaceholderTile = () => (
    <div className='relative flex items-center justify-center h-full overflow-hidden text-5xl border border-transparent rounded cursor-pointer select-none group transform-none opacity-30 bg-tileBackground hover:border-secondaryButtonOutlineHover hover:opacity-100'>
        <span className='transition-all scale-0 group-hover:scale-100'>+</span>
    </div>
);
